import { gql } from "@apollo/client";

export default gql`
  query getInlineCommentsQuery($uuid: String!) {
    me {
      id
      avatar
      name
      avatar
    }
    comments(textUuid: $uuid, isInlineComment: true) {
      totalCount
      edges {
        node {
          id
          creator {
            id
            name
            avatar
          }
          created
          comment
        }
      }
    }
  }
`;
